import styled, {keyframes} from 'styled-components';
import {dFlex, alignCenter} from '../../../globalVariables/GlobalFlex';

const typingBounce = keyframes`
    0%, 60%, 100% {
        opacity: 0.3;
        transform: translateY(0);
    }
    30% {
        opacity: 0.9;
        transform: translateY(-4px);
    }
`;

export const typingBubble = styled.div`
    align-self: flex-start;
    ${dFlex}
    ${alignCenter}
    gap: var(--space-sm);
    padding: var(--space-md) var(--space-lg);
    border-radius: var(--border-radius-border-radius-2xl, 20px);
    background: var(--color-brand-subtle);
`;

export const typingDot = styled.span`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--color-text-default);
    opacity: 0.35;
    animation: ${typingBounce} 1.1s infinite ease-in-out;

    &:nth-child(2) {
        animation-delay: 0.18s;
    }

    &:nth-child(3) {
        animation-delay: 0.36s;
    }

    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }
`;
